import { useMemo } from "react";
import { useLang } from "../context/LangContext";
import { withLangInUrl } from "../utils/i18n";
import Sample from "../assets/Resim1.jpg";
import "../styles/pages/DemoVideo.css";

export default function Home() {
  const { dict, lang } = useLang();
  const hero = dict?.hero ?? {};

  const hasKicker = Boolean(hero.kicker);
  const hasTitle = Boolean(hero.title);
  const hasText = Boolean(hero.text);
  const hasPrimaryCta = Boolean(hero.primaryCta);
  const hasSecondaryCta = Boolean(hero.secondaryCta);

  const particles = useMemo(
    () =>
      Array.from({ length: 8 }, (_, index) => ({
        id: index,
        className: `demovideo-particle demovideo-particle--${(index % 4) + 1}`,
      })),
    []
  );

  const handleSectionClick = (e, hash) => {
    e.preventDefault();

    const targetId = hash.replace("#", "");
    const targetSection = document.getElementById(targetId);

    if (!targetSection) return;

    targetSection.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    window.history.pushState(null, "", withLangInUrl(hash, lang));
  };

  return (
    <section className="demovideo-section page-section" id="hero">
      <div className="demovideo-shell">
        <div className="demovideo-bg-glow demovideo-bg-glow--left" />
        <div className="demovideo-bg-glow demovideo-bg-glow--right" />

        <img
          className="demovideo-image"
          src={Sample}
          alt={hero.alt ?? "Kene Teknoloji su altı sistemleri görseli"}
          loading="eager"
          fetchPriority="high"
        />

        <div className="demovideo-overlay" />

        <div className="demovideo-particles" aria-hidden="true">
          {particles.map((particle) => (
            <span key={particle.id} className={particle.className} />
          ))}
        </div>

        <div className="demovideo-content">
          {hasKicker && <div className="demovideo-kicker">{hero.kicker}</div>}

          {hasTitle && <h1 className="demovideo-title">{hero.title}</h1>}

          {hasText && <p className="demovideo-text">{hero.text}</p>}

          {(hasPrimaryCta || hasSecondaryCta) && (
            <div className="demovideo-actions">
              {hasPrimaryCta && (
                <a
                  href={withLangInUrl("#solutions", lang)}
                  className="demovideo-btn demovideo-btn--primary"
                  onClick={(e) => handleSectionClick(e, "#solutions")}
                >
                  {hero.primaryCta}
                </a>
              )}

              {hasSecondaryCta && (
                <a
                  href={withLangInUrl("#contact", lang)}
                  className="demovideo-btn demovideo-btn--ghost"
                  onClick={(e) => handleSectionClick(e, "#contact")}
                >
                  {hero.secondaryCta}
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}